class Person {
  constructor(id, name, email, phone) {
    return {
      id: id != null ? id : '',
      name: name != null ? name : '',
      email: email != null ? email : '',
      phone: phone != null ? phone : ''
    };
  }
}

export default Person;
